import { ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { CitiHeaderSection } from "./CitiHeaderSection";
import { CitiTripleDipIconSectionWithAdd } from "./CitiTripleDipIconSectionWithAdd";
import { CitiTripleDipIconSectionWithoutAdd } from "./CitiTripleDipIconSectionWithoutAdd";

enum TitleTexts {
  TRIPLE_DIP_HEADING = "triple_dip_section_Heading",
  TRIPLE_DIP_ICON_SEC_ONE = "triple_dip_section_Icon_Section1",
  TRIPLE_DIP_ICON_SEC_TWO = "triple_dip_section_Icon_Section2",
  TRIPLE_DIP_ICON_SEC_THREE = "triple_dip_section_Icon_Section3",
}

export const CitiTripleDipSectionEditorial = (props: ContentProps) => {
  const { model } = props.flexComponent;

  return (
    <>
      {model.title === TitleTexts.TRIPLE_DIP_HEADING && (
        <CitiHeaderSection flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}

      {model.title === TitleTexts.TRIPLE_DIP_ICON_SEC_ONE && (
        <CitiTripleDipIconSectionWithAdd
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}

      {model.title === TitleTexts.TRIPLE_DIP_ICON_SEC_TWO && (
        <CitiTripleDipIconSectionWithAdd
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}

      {model.title === TitleTexts.TRIPLE_DIP_ICON_SEC_THREE && (
        <CitiTripleDipIconSectionWithoutAdd
          flexComponent={props.flexComponent}
          l10n={props.l10n}
          context={props.context}
        />
      )}
    </>
  );
};

export default CitiTripleDipSectionEditorial;
